import React from 'react';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

interface DividerLineProps extends ForwardedHTMLProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

export const DividerLine = React.forwardRef<HTMLHRElement, DividerLineProps>(
  ({ orientation = 'horizontal', className, ...props }, ref) => {
    const tef = useTEF();
    const forwardedProps = forwardProps(props);

    if (orientation === 'vertical') {
      return (
        <div
          ref={ref as React.Ref<HTMLDivElement>}
          className={cn('w-px h-full', tef.colors.border, className)}
          {...forwardedProps}
          {...props}
        />
      );
    }

    return (
      <hr ref={ref} className={cn('border-0 border-t', tef.colors.border, className)} {...forwardedProps} {...props} />
    );
  }
);

DividerLine.displayName = 'DividerLine';
